import { InvalidServiceError } from '../../domain/errors/InvalidServiceError';
import type { ServicesRepository } from '../../domain/repositories/ServicesRepository.interface';
import type { ServiceDto } from '../dto/ServiceDto';
import { ApplicationError, ValidationError, type Logger } from '@dma/shared';

export class GetServiceBySlugUseCase {
  constructor(
    private readonly repository: ServicesRepository,
    private readonly logger: Logger
  ) {}

  public async execute(slug: string): Promise<ServiceDto> {
    let service;
    try {
      service = await this.repository.getBySlug(slug);
    } catch (error) {
      if (error instanceof InvalidServiceError) {
        this.logger.error('Service content failed domain validation', {
          slug,
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('SERVICE_UNAVAILABLE', 'این خدمت در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }

    if (!service) {
      throw new ValidationError(`خدمتی با شناسه‌ی "${slug}" یافت نشد.`);
    }

    return service.props;
  }
}
